import { Component, For } from "solid-js";

/** Deterministic title widths to avoid uniform-looking skeleton rows */
const TITLE_WIDTHS = [
  "w-48",
  "w-64",
  "w-36",
  "w-56",
  "w-44",
  "w-60",
  "w-40",
  "w-52",
  "w-48",
  "w-56",
  "w-36",
  "w-64",
];

/**
 * BacklogSkeleton - Shimmer loading placeholder that mirrors BacklogRow layout.
 *
 * Shows placeholder rows matching the backlog row structure:
 *   Drag handle spacer | Type icon | Display ID | Title | Priority dot | Status badge
 */
export const BacklogSkeleton: Component<{ rows?: number }> = (props) => {
  const rowCount = () => props.rows ?? 12;
  const rows = () => Array.from({ length: rowCount() }, (_, i) => i);

  return (
    <div role="status" aria-label="Loading backlog items" aria-busy="true">
      {/* Skeleton header row (matches SelectAllHeader) */}
      <div class="flex items-center h-8 px-6 bg-paper border-b border-line">
        <div class="w-6 shrink-0 mr-1" />
        <div class="skeleton w-3.5 h-3.5 rounded mr-2" />
        <div class="skeleton w-24 h-3 rounded" />
      </div>

      {/* Skeleton content rows */}
      <For each={rows()}>
        {(index) => (
          <div
            class="flex items-center h-8.25 px-6 border-b border-line"
            style={{ "--skeleton-delay": `${index * 50}ms` }}
          >
            {/* Drag handle spacer */}
            <div class="w-6 shrink-0 mr-1" />

            {/* Checkbox spacer */}
            <div class="w-3.5 shrink-0 mr-2" />

            {/* Type icon */}
            <div class="skeleton w-4 h-4 rounded shrink-0 mr-1.5" />

            {/* Display ID */}
            <div class="skeleton w-14 h-3 rounded shrink-0 mr-2" />

            {/* Title - variable width */}
            <div
              class={`skeleton h-3.5 rounded shrink-0 mr-3 ${TITLE_WIDTHS[index % TITLE_WIDTHS.length]}`}
            />

            {/* Spacer to push right-aligned items */}
            <div class="flex-1" />

            {/* Estimate (hidden below xl) */}
            <div class="hidden xl:block skeleton w-8 h-3 rounded mr-2" />

            {/* Priority meter (hidden below md) */}
            <div class="hidden md:flex items-center justify-center w-5 shrink-0 mr-2">
              <div class="skeleton w-2 h-2 rounded-full" />
            </div>

            {/* Status badge */}
            <div class="skeleton w-20 h-5 rounded-sm shrink-0" />
          </div>
        )}
      </For>
    </div>
  );
};
